import React from 'react';
import {Form, Row, Col} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import * as validators from 'utils/validators';
import {makeForm} from 'utils/common';
import {fetchClassrooms} from 'api/classrooms';
import {Field} from 'redux-form';
import * as fields from '../common/fields';

class SchoolAssignedSubscriptionForm extends React.Component {
  constructor(props) {
    super(props);
    this.fetchSchoolClassrooms = this.fetchSchoolClassrooms.bind(this);
  }

  fetchSchoolClassrooms(value) {
    const {schoolId} = this.props;
    return fetchClassrooms(value, undefined, undefined, undefined, {schoolId}).then(({records}) => records);
  }

  render() {
    const {handleSubmit, pristine, submitting} = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={12}>
            <Field
              name="availableSubscriptions"
              label="Available Subscriptions"
              component={fields.Input}
              required
              validate={[validators.isRequired, validators.isIntGTEZero]}
              type="number"
              min="0"
              step="1"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={pristine || submitting}>
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = (state, {classroomSubscriptionData: {availableSubscriptions}}) => {
  return {
    initialValues: {
      availableSubscriptions,
    },
  };
};

export default makeForm(SchoolAssignedSubscriptionForm, 'SchoolAssignedSubscriptionForm', mapStateToProps, null);
